import { PlanVariantsWrapperProps, PlanVariantsWrapperStateProps, PlanType } from '../../types/components/pricing/PlanVariantsWrapper';
import { User } from '../../types/api/UsersTypes';
import { SubscriptionDetail, SubscriptionInterval } from '../../types/api/SubscriptionTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import IntervalSelector from './IntervalSelector';
import PlanVariantDetailsCard from './PlanVariantDetailsCard';

import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import pricingHelpers from '../../helpers/pages/pricing/pricing';

import { ENTERPRISE_PRICING_PAGE_URL } from '../../constants/ui';

export const planVariantsGridClasses = {
  1: 'grid grid-cols-1 gap-[29px] px-[24px]',
  2: 'grid grid-cols-1 md:grid-cols-2 gap-[29px] px-[24px]',
  3: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[29px] px-[24px]',
  4: 'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-[29px] px-[24px]',
};

const PlanVariantsWrapper: React.FC<PlanVariantsWrapperProps> = ({
  planVariants,
  pageContent,
  user,
  subscription,
}) => {
  const router = useRouter();
  const { filterPlanCards, getPlanVariantDetailsCardProps } = pricingHelpers;

  const [filteredPlanTypes, setFilteredPlanTypes] = useState<Array<PlanType>>();
  const [selectedInterval, setSelectedInterval] = useState<SubscriptionInterval>();
  const isEnterprisePricingPage = router.asPath.includes(ENTERPRISE_PRICING_PAGE_URL) || router.asPath.includes('/enterprise?');

  useEffect(() => {
    // TODO test enterprise behavior
    const isEnterprisePricingPage = router.asPath.includes(ENTERPRISE_PRICING_PAGE_URL);
    const excludeOption: Array<PlanType> = isEnterprisePricingPage ? ['free', 'individual', 'startup'] : [];
    const filteredPlanTypes = filterPlanCards(user, subscription, { excludeOption });
    setFilteredPlanTypes(filteredPlanTypes);
  }, [user, subscription]);

  const determineCardContainerStyling = () => {
    if (!filteredPlanTypes?.length) return planVariantsGridClasses[4];
    return planVariantsGridClasses[filteredPlanTypes.length];
  };

  return (
    <>
      <IntervalSelector
        selectedInterval={selectedInterval}
        setSelectedInterval={setSelectedInterval}
        intervalTag={pageContent.interval_tag}
      />
      <section className="flex items-center justify-center">
        <div className={determineCardContainerStyling()} cy-test-id="plan-cards-wrapper-div">
          {filteredPlanTypes?.map(
            (planType, index) => (
              <div>
                <PlanVariantDetailsCard
                  {...getPlanVariantDetailsCardProps(
                    planType,
                    planVariants,
                    pageContent,
                    selectedInterval,
                    router,
                    isEnterprisePricingPage
                  )}
                  key={index}
                />
              </div>
            )
          )}
        </div>
      </section>
    </>
  )
};

const mapStateToProps = (state: ApplicationState): PlanVariantsWrapperStateProps => ({
  subscription: state.auth.subscription as SubscriptionDetail,
  user: state.auth.user as User,
})

export default connect(mapStateToProps)(PlanVariantsWrapper);
